import React, { useEffect, useState } from 'react'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Text from 'components_new/atoms/Text'

import DndList from 'components_new/molecules/DndList'
import SimpleDialog from 'components_new/molecules/SimpleDialog'

import DragItem from './DragItem'
import { getPutOrder } from './utils'

import { useKpiVariableActions } from 'redux/actions/KpiVariables'

import { KpiVariable } from 'types/GlobalKpiVariable'
import { useTranslation } from 'language/translator'

interface EditKpiVariableOrderDialogProps {
  id?: string
  open: boolean
  onClose: () => void
  variables: KpiVariable[]
}

const EditKpiVariableOrderDialog = (props: EditKpiVariableOrderDialogProps) => {
  const { variables } = props
  const { tryPutSortedKpiVariables } = useKpiVariableActions()

  const [order, setOrder] = useState<KpiVariable[]>([])
  const { t } = useTranslation()

  useEffect(() => {
    if (props.open) {
      let variablesToOrder = [...variables]

      if (props.id) {
        variablesToOrder = variablesToOrder.filter(
          (v) => v.parent_kpi_variable_id === props.id
        )
      } else {
        variablesToOrder = variablesToOrder.filter((v) => v.level === 0)
      }

      setOrder([...variablesToOrder])
    }
  }, [props.open])

  return (
    <SimpleDialog
      actions={
        <>
          <Button onClick={props.onClose} variant="text">
            {t('global', 'cancel')}
          </Button>
          <Button
            onClick={() => {
              tryPutSortedKpiVariables(getPutOrder(variables, order, props.id))

              props.onClose()
            }}
          >
            {t('global', 'save')}
          </Button>
        </>
      }
      open={props.open}
      onClose={props.onClose}
      title={
        <Text variant="h3" gutterBottom={true}>
          {t('global', 'edit_order')}
        </Text>
      }
      sx={{ zIndex: 1302 }}
    >
      <Box sx={{ maxWidth: 'title', mb: 2 }}>
        <Text variant="subtitle2" gutterBottom={true}>
          {t('accounting', 'account_levels_description')}
        </Text>
      </Box>
      <DndList
        editable={true}
        handleDragEnd={(newOrder) => {
          setOrder((prevState) => {
            return newOrder.map((id, index) => {
              const element = prevState.find(
                (item) => item.id === id
              ) as KpiVariable

              return {
                ...element,
                index
              }
            })
          })
        }}
        itemGap={8}
        itemHeight={40}
        items={order.map((item, i) => {
          return {
            id: item.id,
            content: <DragItem index={i + 1} title={item.name} />,
            containerSx: {
              p: 1
            }
          }
        })}
      />
    </SimpleDialog>
  )
}

export default EditKpiVariableOrderDialog
